import * as React from "react"
const IconAcessoCV = ({ width, height }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        viewBox="0 0 60 60"
        width={width}
        height={height}
    >
        <path
            d="M0 0h60v60H0z"
            style={{
                fill: "#eae0d8",
            }}
        />
        <path
            d="M1.84 1.84h56.32v56.32H1.84z"
            style={{
                fill: "none",
                stroke: "#354060",
                strokeMiterlimit: 10,
            }}
        />
        <path
            d="M28.9 50.47c-5.14-.5-9.82-4.84-11.15-9.73-.58-2.14-.66-5.92-.47-8.16.14-1.57 1.35-2.76 2.83-3.17V15.67c.2-2.47 2.8-4.01 5.07-2.93 1 .48 2.02 1.8 2.02 2.94v7.3c1.82-1.33 4.65-.53 5.38 1.62 1.98-1.6 4.63-.89 5.68 1.37 2.2-1.72 5.36-.57 5.82 2.2-.21 6.02 1.2 11.95-2.68 17.09-1.98 2.62-5.61 4.9-8.92 5.22h-.68c-1.29-1.5.65-1.43 1.62-1.66 3.46-.84 6.45-3.12 8.02-6.33 2.09-4.28.89-9.46 1.21-14.08-.31-2.38-3.8-2.42-4.16-.06-.09.59.1 1.47-.06 1.99-.21.69-1.24.59-1.39-.15-.27-1.35.49-3.33-.63-4.41-1.02-.99-2.79-.69-3.38.61-.5 1.1.04 2.77-.21 3.89-.16.73-1.3.72-1.43-.16-.19-1.34.12-3.05 0-4.44-.15-1.64-2.05-2.48-3.38-1.49-1.5 1.12-.5 4.34-.83 6-.14.69-1.03.87-1.37.21l-.09-14.77c-.46-2.4-3.8-2.34-4.16.06v20.06c-.11.57-.63.94-1.16.56-.07-.05-.3-.33-.3-.39v-5c-.73.28-1.3.95-1.37 1.75-.19 2.14-.12 5.86.47 7.9 1.21 4.16 4.57 7.23 8.75 8.24.98.24 2.91.17 1.62 1.66-.22-.02-.46.02-.68 0ZM17.52 9.58c.2-.04.41.05.58.16.2.13 2.01 1.94 2.13 2.14.43.68-.23 1.38-.99.99-.23-.12-1.89-1.77-2.07-2.03-.32-.47-.3-1.14.35-1.26ZM23.12 6.95c.48-.48 1.15-.1 1.24.53.07.52.08 2.29 0 2.8-.14.91-1.31.92-1.44.09-.08-.53-.08-2.44 0-2.99a.81.81 0 0 1 .2-.44ZM29.47 9.58c.55-.1 1.11.54.78 1.04L28 12.9c-.68.33-1.34-.28-.98-.98.09-.18 1.88-1.97 2.12-2.15.1-.08.19-.17.32-.2Z"
            style={{
                fill: "#354060",
            }}
        />
    </svg>
)
export default IconAcessoCV
